import React from 'react';
import { Tag } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

const SelectedItems = ({ items, onRemove }) => {
  // Generates the Tag component for each item
  console.log('items', items)
  const renderTag = (type, name) => (
    <Tag
      closable
      onClose={() => onRemove(type, name)}
      key={`${type}-${name}`}
      style={{ margin: '5px', fontSize: '14px', border: '1px dashed #ddd', background: 'transparent' }}
      bordered={false}
      closeIcon={<CloseCircleFilled style={{color: 'red'}} />}
    >
      <span style={{fontSize: '11px'}}>{type.toUpperCase()}</span> <b>{name.toUpperCase()}</b>
    </Tag>
  );

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }} className={'p-4'}>
      {items && Object.entries(items).map(([type, names]) =>
        names?.map?.(name => renderTag(type, name))
      )}
    </div>
  );
};

export default SelectedItems;
